import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=122d7ba3"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports